<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>

<ng-template #typ00>
  <cap-link [enableNavigation]="canViewGeoGeschaeftDetails" [params]="[item?.timePoint.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
    <span>{{ item?.namePolitischeGemeinde }}, {{ item?.timePoint.geschaeftsnummer | formatGeometergeschaeftsnummer }}</span>
  </cap-link>
</ng-template>
